'use client';

import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import LogoBar from './components/LogoBar';
import ComparisonTable from './components/ComparisonTable';
import AlumniSection from './components/AlumniSection';
import SignupSection from './components/SignupSection';
import EditingChatbot from './components/EditingChatbot';

export default function HomePage() {
  const [showPopup, setShowPopup] = useState(true);

  return (
    <main
      className="min-h-screen"
      style={{ background: '#0B1A2E' }}>

      <Header />
      <HeroSection />
      <LogoBar />
      <ComparisonTable />
      <AlumniSection />
      <SignupSection />
      <Footer />

      <EditingChatbot />

      {showPopup &&
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
          <div className="bg-white rounded-2xl shadow-2xl px-10 py-8 flex flex-col items-center gap-4 min-w-[260px]">
            <h2 className="text-2xl font-bold text-gray-800 tracking-wide">version 7</h2>
            <button
            onClick={() => setShowPopup(false)}
            className="mt-2 px-6 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors">

              Close
            </button>
          </div>
        </div>
      }
    </main>);

}